"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridHeaderBoxId = exports.gridHeaderCellId = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const features_1 = require("../features");
const getFlexStyleForColumn_1 = __importDefault(require("../utils/getFlexStyleForColumn"));
const GridToggleMenu_1 = require("./GridToggleMenu");
const HeaderBox = styled_components_1.default.div `
    overflow: hidden;
    border-bottom: 2px solid ${(props) => props.theme.colorBorderMain};
    height: ${(props) => `${props.headerHeight}px`};
    box-sizing: border-box;

    position: relative;
    display: flex;
    align-items: center;

    ${(props) => props.isEmpty &&
    (0, styled_components_1.css) `
            width: ${props.rowWidth}px;
        `}
`;
const Header = styled_components_1.default.div `
    display: flex;
    align-items: center;
    flex: 0 0 ${(props) => `${props.rowWidth}px`};
    height: 100%;
`;
exports.gridHeaderCellId = 'grid-header-cell-in-row';
const GridHeaderCells = () => {
    const { state: { columnsWidth } } = (0, features_1.useGridContext)();
    const { visibleColumns } = (0, features_1.useGridToggleableContext)();
    return (react_1.default.createElement(react_1.default.Fragment, null, visibleColumns.map((column) => {
        const columnWidth = columnsWidth[column.key];
        const columnMinWidth = column.props.minWidth;
        const computedStyle = (0, getFlexStyleForColumn_1.default)(column, {
            isHeaderCell: true,
            width: columnWidth
        });
        return (react_1.default.createElement("div", { "data-selector-id": exports.gridHeaderCellId, key: `Header-${column.key}`, style: computedStyle }, !!column.props.headerCell &&
            react_1.default.createElement(column.props.headerCell, {
                cellData: column.props.title,
                headerJustify: column.props.headerJustify,
                totalColumn: column.props.totalColumn,
                columnKey: column.key,
                columnMinWidth,
                columnWidth,
                contentRenderer: column.props.headerCellContent,
                columnField: column.props.field,
                columnId: column.props.columnId,
                onHeaderClick: column.props.onHeaderClick
            })));
    })));
};
exports.gridHeaderBoxId = 'grid-header-box';
const GridHeader = (0, react_1.forwardRef)((props, ref) => {
    const { state: { headerHeight, hideHeader, isEmpty, toggleable } } = (0, features_1.useGridContext)();
    const { rowWidth } = (0, features_1.useGridToggleableContext)();
    if (hideHeader) {
        return null;
    }
    return (react_1.default.createElement(HeaderBox, { "data-selector-id": exports.gridHeaderBoxId, headerHeight: headerHeight, rowWidth: rowWidth, isEmpty: isEmpty },
        react_1.default.createElement(Header, { rowWidth: rowWidth, ref: ref },
            react_1.default.createElement(GridHeaderCells, null)),
        toggleable && react_1.default.createElement(GridToggleMenu_1.GridToggleMenu, null)));
});
exports.default = GridHeader;
//# sourceMappingURL=GridHeader.js.map